import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const recipesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'recipes/update':
            return {
                ...state,
                ...action.payload
            };

        case 'recipes/clear':
            return initialState;

        default:
            return state;
    }
};

export default recipesReducer;